import {AsyncPipe, DatePipe} from '@angular/common';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatDialog} from '@angular/material/dialog';
import {MatDivider} from '@angular/material/divider';
import {MatIcon} from '@angular/material/icon';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';

import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatSort, MatSortHeader} from '@angular/material/sort';
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
} from '@angular/material/table';
import {Router} from '@angular/router';
import {AssetStreamDialogComponent} from '@app/admin/asset-stream-dialog/asset-stream-dialog.component';
import {Client, ClientService} from '@app/admin/client.service';

import {Asset, AssetService, IconMap} from '@app/asset';
import {BytesPipe} from '@app/shared/bytes.pipe';
import {ManagedComponent} from '@app/shared/managed.component';
import {StreamMoveMenuComponent} from '@app/stream/stream-move-menu/stream-move-menu.component';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';

@Component({
    selector: 'frog-content-admin',
    templateUrl: './content-admin.component.html',
    styleUrls: ['./content-admin.component.scss'],
    imports: [
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatSortHeader,
        MatIcon,
        MatCheckbox,
        MatIconButton,
        MatMenuTrigger,
        MatMenu,
        MatMenuItem,
        MatDivider,
        StreamMoveMenuComponent,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        DatePipe,
        BytesPipe,
        AsyncPipe,
    ],
})
export class ContentAdminComponent extends ManagedComponent implements OnInit {
    public client$: Observable<Client>;
    displayedColumns: string[] = [
        'thumbnail',
        'name',
        'author',
        'type',
        'created',
        'modified',
        'source_size',
        'views',
        'likes',
        'hidden',
        'deleted',
        'history',
    ];
    data: Asset[] = [];
    resultsLength = 0;
    isLoadingResults = true;
    isRateLimitReached = false;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    public IconMap = IconMap;

    constructor(
        private assetService: AssetService,
        private clientService: ClientService,
        private matDialog: MatDialog,
        private router: Router,
    ) {
        super();
    }

    ngOnInit(): void {
        this.client$ = this.clientService.client;
    }

    ngAfterViewInit() {
        // If the user changes the sort order, reset back to the first page.
        this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

        const sub = merge(this.sort.sortChange, this.paginator.page)
            .pipe(
                startWith({}),
                switchMap((page: PageEvent) => {
                    this.isLoadingResults = true;
                    const ordering = (this.sort.direction === 'asc' ? '' : '-') + this.sort.active;
                    return this.assetService.listAssets(page.pageIndex, ordering);
                }),
                map((data) => {
                    // Flip flag to show that loading has finished.
                    this.isLoadingResults = false;
                    this.isRateLimitReached = false;
                    this.resultsLength = data.count;

                    return data.results;
                }),
                catchError(() => {
                    this.isLoadingResults = false;
                    // Catch if the GitHub API has reached its rate limit. Return empty data.
                    this.isRateLimitReached = true;
                    return observableOf([]);
                }),
            )
            .subscribe((data) => (this.data = data));
        this.subscriptions.push(sub);
    }

    updateAsset(asset: Asset, key: string, value: any) {
        asset[key] = value;
        const data = {};
        data[key] = value;
        this.assetService.updateAsset(asset.id, data);
    }

    history(asset: Asset) {
        this.assetService.history(asset.id).subscribe((results) => {});
    }

    viewAsset(asset: Asset) {
        const url = this.router.serializeUrl(this.router.createUrlTree([`/v/0/${asset.id}`]));

        window.open(url, '_blank');
    }

    streams(asset: Asset) {
        this.assetService.streams(asset.id).subscribe((streams) => {
            this.matDialog.open(AssetStreamDialogComponent, {
                data: {
                    asset: asset,
                    streams: streams,
                },
                width: '60vw',
            });
        });
    }

    delete(asset: Asset) {
        this.updateAsset(asset, 'deleted', true);
    }
}
